import styles from "./AboutTheAuthors.module.scss";
import { gql } from "utils/urql";
import { Fragment } from "react";
import { AboutTheAuthorsFragment } from "types/api";

const AboutTheAuthors = ({ authors }: AboutTheAuthorsFragment) => {
  return (
    <section className={styles.root}>
      <p className={styles.content}>
        <span className={styles.label}>{`About the author${
          authors.length > 1 ? "s" : ""
        }: `}</span>
        {authors.map((author, i) => {
          return (
            author.biography?.default && (
              <Fragment key={`about-author-${i}`}>
                <span
                  className={styles.authorBio}
                  dangerouslySetInnerHTML={{
                    __html: author.biography.default,
                  }}
                />{" "}
              </Fragment>
            )
          );
        })}
      </p>
    </section>
  );
};
export default AboutTheAuthors;

AboutTheAuthors.fragment = gql`
  fragment aboutTheAuthors on Article {
    authors {
      id
      url
      displayName
      biography {
        default
      }
    }
  }
`;
